import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getMobileSdkIssueDetails } from 'src/apps/mobile-sdk/services/MobileSdkDashboardService';
import { MOBILE_SDK_ISSUE_DETAILS } from 'src/common/providers/reactQueryProvider/QueryKeys';
import { MobileIssueDetails } from 'src/common/types/MobileSingleSessionTypes';

export const useMobileSdkIssueDetailsQuery = (
	issueId: string,
	testId: string
): UseQueryResult<MobileIssueDetails> => {
	const issueDetailsQuery = useQuery([MOBILE_SDK_ISSUE_DETAILS, issueId, testId], () =>
		getMobileSdkIssueDetails(issueId, testId)
	);

	return issueDetailsQuery;
};
